export default "__VITE_ASSET__DDHLzTWr__"